import Axios from 'api/client';

const fetchTimeZones = () => Axios.get<string[]>(`/timezones`).then(response => response.data);

export { fetchTimeZones };
